// Persona de contacto según el idioma de la web: en italiano atiende Francesco Gioia (su móvil y su
// WhatsApp); en el resto de idiomas, Adrián Ruiz con el número de la empresa. Lo usan la tarjeta del hero
// de la home («Llámanos ahora»), el botón de llamar del contacto de la home, el WhatsApp flotante y el
// icono de WhatsApp de /apps. El evento de conversión de Google Ads «whatsapp_click» cuenta cualquier
// enlace wa.me, así que vale para los dos números.

export interface ContactPerson {
  name: string;
  /** foto cuadrada para la tarjeta (public/landing/inicio) */
  img: string;
  /** teléfono en formato internacional para tel: */
  tel: string;
  /** número para wa.me (sin + ni espacios) */
  wa: string;
}

const ADRIAN: ContactPerson = { name: "Adrián Ruiz", img: "/landing/inicio/team-adrian.jpg", tel: "+34638684896", wa: "34638684896" };
const FRANCESCO: ContactPerson = { name: "Francesco Gioia", img: "/landing/inicio/team-francesco.jpg", tel: "+393457841984", wa: "393457841984" };

export function contactFor(lang: string): ContactPerson {
  return lang === "it" ? FRANCESCO : ADRIAN;
}

/** Primer mensaje ya escrito al abrir WhatsApp, en el idioma de la web. */
export const WA_HELLO: Record<string, string> = {
  es: "Hola, me gustaría saber más sobre Ulture.",
  en: "Hi, I'd like to know more about Ulture.",
  it: "Ciao, vorrei avere più informazioni su Ulture.",
  fr: "Bonjour, je voudrais en savoir plus sur Ulture.",
  nl: "Hallo, ik wil graag meer weten over Ulture.",
  ar: "مرحبًا، أود معرفة المزيد عن Ulture.",
  zh: "你好，我想进一步了解 Ulture。",
};

export function waLink(lang: string): string {
  return `https://wa.me/${contactFor(lang).wa}?text=${encodeURIComponent(WA_HELLO[lang] || WA_HELLO.es)}`;
}

/** Móvil o tableta (sin ratón): llamar. Ordenador: WhatsApp. */
export function isTouchDevice(): boolean {
  try {
    return !window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  } catch {
    return false;
  }
}

/** Botón «Llámanos»: en el móvil abre la llamada; en el ordenador, WhatsApp en otra pestaña. */
export function callLink(lang: string): { href: string; target?: string; rel?: string } {
  const p = contactFor(lang);
  return isTouchDevice() ? { href: `tel:${p.tel}` } : { href: waLink(lang), target: "_blank", rel: "noopener" };
}
